import fetch from './fetch';
/**
 * 获取token信息
 * @method loginByEmail
 */
export function loginByEmail(obj) {
    return fetch({
      url: '/api/auth/jwt/token',
      method: 'post',
      data: obj
    });
  }
  /**
   * 获取全部订单
   * @method listOrder
   */
  export function listOrder(query) {
    return fetch({
      url: '/api/app/miniApp/listOrder',
      method: 'get',
      params: query
    });
  }
/**
 * 获取订单详情
 * @method getOrderDetail
 */
export function getOrderDetail(query) {
  return fetch({
    url: '/api/app/miniApp/getOrderDetail',
    method: 'get',
    params: query
  });
}
/**
 * 获取保修列表
 * @method listQuestionnaire
 */
export function listQuestionnaire(query) {
  return fetch({
    url: '/api/app/miniApp/listQuestionnaire',
    method: 'get',
    params: query
  });
}
/**
 * 获取预算列表
 * @method listOrderBudget
 */
export function listOrderBudget(query) {
  return fetch({
    url: '/api/app/miniApp/listOrderBudget',
    method: 'get',
    params: query
  });
}
/**
 * 获取预算详情
 * @method listOrderBudgetDetail
 */
export function listOrderBudgetDetail(query) {
  return fetch({
    url: '/api/app/miniApp/listOrderBudgetDetail',
    method: 'get',
    params: query
  });
}
/**
 * 新增报修申请
 * @method addQuestionnaire
 */
export function addQuestionnaire(obj) {
  return fetch({
    url: '/api/app/miniApp/addQuestionnaire',
    method: 'post',
    data: obj
  });
}
/**
 * 获取合同列表
 * @method addQuestionnaire
 */
export function listOrderContract(query) {
  return fetch({
    url: '/api/app/miniApp/listOrderContract',
    method: 'get',
    params: query
  });
}
/**
 * 获取预约列表
 * @method addQuestionnaire
 */
export function addActivityAppointment(query) {
  return fetch({
    url: '/api/app/miniApp/addActivityAppointment',
    method: 'get',
    params: query
  });
}
/**
 * 手机号验证
 * @method addQuestionnaire
 */
export function sendSms(query) {
  return fetch({
    url: '/api/app/miniApp/sendSms',
    method: 'get',
    params: query
  });
}
/**
 * 获取用户信息
 * @method addQuestionnaire
 */
export function getCustomerInfo(query) {
  return fetch({
    url: '/api/app/miniApp/getCustomerInfo',
    method: 'get',
    params: query
  });
}
/**
 * 活动列表
 * @method listActivity
 */
export function listActivity(query) {
  return fetch({
    url: '/api/app/miniApp/listActivity',
    method: 'get',
    params: query
  });
}
/**
 * 活动详情
 * @method getActivityDetail
 */
export function getActivityDetail(query) {
  return fetch({
    url: '/api/app/miniApp/getActivityDetail',
    method: 'get',
    params: query
  });
}
/**
 * 签订合同
 * @method getActivityDetail
 */
export function signContract(obj) {
  return fetch({
    url: '/api/app/miniApp/signContract',
    method: 'put',
    data: obj
  });
}